/*
export const someGetter = (state) => {}
 */

export default {
}
